var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_26163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 25.5222C22.9283 27.8799 19.6341 29.3337 16.0001 29.3337C8.63628 29.3337 2.66675 23.3641 2.66675 16.0003C2.66675 8.63653 8.63628 2.66699 16.0001 2.66699C19.7299 2.66699 23.1021 4.19851 25.5219 6.66699",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 20C11.8829 21.6192 13.8191 22.6667 16.0001 22.6667C16.9482 22.6667 17.8501 22.4687 18.6667 22.1119",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6787 12H10.6667",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 17.333C23.5424 17.333 25.3333 15.5421 25.3333 13.333C25.3333 11.1239 23.5424 9.33301 21.3333 9.33301C19.1241 9.33301 17.3333 11.1239 17.3333 13.333C17.3333 15.5421 19.1241 17.333 21.3333 17.333Z",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 15.9997C29.0569 15.4718 28.9186 15.2079 28.7359 14.9767C28.2686 14.3855 27.5711 13.9206 26.741 13.6469C26.4165 13.5398 26.0554 13.4709 25.3333 13.333",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_26163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInspection);
export default __webpack_public_path__ + "static/media/viewInspection.9ef1dd1b6cd510ce6182e28d004a21f6.svg";
export { ForwardRef as ReactComponent };